/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
const makeDate = (thing: any): void => {
    if (!thing) {
        return
    }

    if (Array.isArray(thing)) {
        thing.forEach(makeDate)
        return
    }

    Object.entries(thing).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(makeDate)
            return
        }

        if (value && key.endsWith('At')) {
            const date = new Date(value as string)
            if (Number(date)) {
                thing[key] = date
            }
            return
        }

        if (value && typeof value === 'object') {
            makeDate(value)
        }
    })
}

export default makeDate
